// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Pattern 2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: 'Sora', sans-serif;
}
#root{
    background-color: #F1F5F7;

}
.yerimLogoRegister{
    width: 229px !important;
    height: 180px !important;
    margin-bottom: 35px;
}

.register-container-col{
    background-color: #FFFF;
    padding: 72px !important;
}
.css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{
    /* margin-bottom: 24px; */
    height: 60px !important;
}
.css-md26zr-MuiInputBase-root-MuiOutlinedInput-root{
    margin-bottom: 24px;
    height: 60px !important;
}
.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{
background-color: white !important;
}
.companyRegisterForm {
    background-color: #F9FBFC;
    padding: 32px;
    border-radius: 20px;
    margin-bottom: 50px;
}
.companyInfoTitle{
    font-weight: 200;
    margin-top: 50px;
}
.logoBackgroundDivRegister {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 400px;
    background-position: right;
    background-size: 460px;
    margin-bottom: 100px;
}

.RegisterTitle {
    font-weight:100;
    width: 700px;
    font-size: 36px;
    line-height: 46px;
    color: #1D1E25;

}

.RegisterSubtitle {
    font-weight: 200;
    width: 500px;
    font-size: 16px;
    line-height: 26px;
    color: #1D1E25;
}

.companyRegisterTitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;
}

#inputArea {
    background-color: #FFFF;
    height: 55px;
    border-radius: 8px;
    border: 1px solid #1D1E2533;
    font-size: 16px;
    font-weight: 300;
    color: #1D1E25;

}
#inputArea:focus{
    box-shadow: none;
    border: 2px solid #F9B061;
    outline: none;
}

#select-box{
    color: #1D1E2566 !important;
}
#select-box:focus{
    box-shadow: none;
    border: 2px solid #F9B061;
    outline: none;
}


.css-152mnda-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled{
    color: black !important;
}
.form-control{
    margin-bottom: 0px !important;
}
.input-container {
    position: relative;
    margin-bottom: 1.5rem;

}


.input-container label {
    position: absolute;
    top: 50%;
    left: 2.5rem; 
    transform: translateY(-50%);
    color: #1D1E25;
    font-weight: 300;
    transition: all 0.2s ease;
    pointer-events: none;
  }
  
  .input-container input:focus + label,
  .input-container input:not(:placeholder-shown) + label {
    top: 0;
    left: 2.5rem;
    transform: translateY(15%);
    font-size: 0.60rem;
    color: #1D1E25;
  }
  
  .input-container input {
    padding: 0.75rem 2.5rem;
  }


.input-container select {
    padding-left: 50px;
    font-size: 16px;
    font-weight: 400;
    width: 100%;
    height: 50px;
    border-radius: 8px;
    border: 1px solid #1D1E2533;
    font-size: 16px;
    font-weight: 300;
    color: #1D1E25 !important;
    outline: none;
}
.weblink{
    margin-right: 35px !important;
}
.icons {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    pointer-events: stroke;
}

.input-container input::placeholder {
    padding-left: 10px;
}

.input-container select {
    padding-left: 50px;
    color: #1D1E25;
    font-size: 16px;
    font-weight: 400;
  }
  
.input-container input {
    padding-left: 40px;
}
.website-link input{
    padding-left: 62px;
}
.website-link input::placeholder{
    padding-left: 0px;
}
.uploadCompanyLogoImage{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 25px;
    background-color: #FFFF;
    border: 2px dashed #1D1E2533;
    border-radius: 15px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #1D1E25;
    font-weight: 200;
}
.uploadImage {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 25px;
    background-color: #FFFF;
    border: 2px dashed #1D1E2533;
    border-radius: 15px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #1D1E2566;
    font-weight: 200;
}

.uploadImage label {
    margin-left: 15px;
}

.uploadImage input[type="file"] {
    margin-top: -50px;
    cursor: pointer !important;
}

.uploadImageIcon {
    padding: 20px;
    background-color: #F1F5F7;
    z-index: -1;
    border-radius: 35px;
}

.infoPassword {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 20px;
    margin-top: 20px;
}

.uploadPDF {
    display: grid;
    align-items: center;
    justify-content: center;
    justify-items: center;
    padding: 35px;
    background-color: #FFFF;
    border: 2px dashed #1D1E2533;
    margin-bottom: 30px;
    border-radius: 15px;
    font-size: 14px;
    color: #1D1E25;
    font-weight: 200;
}

.uploadPDFIcon {
    padding: 20px;
    background-color: #87CCA1;
    margin-bottom: 15px;
    z-index: -1;
    border-radius: 35px;
}

.uploadPDF input[type="file"] {
    cursor: pointer !important;
}

.signUpButton {
    background-color: #F15F50;
    justify-content: space-between;
    border: none;
    padding: 18px 22px 18px 22px;
    width: 312px;
    height: 56px;
    border-radius: 12px;
}
.signUpButton:hover{
    background-color: #ed5746;
}
.bottomLinks {
    text-align: right;
}

.link {
    margin-top: 10px;
    font-size: 16px;
    color: #1D1E25;
    font-weight: 400;
}

.select-container {
    color: #1D1E25 !important;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  
  .dropdown-icon {
    margin-left: -30px;
    cursor: pointer;
  }

  .remove-segment-button{
    border: none;
    padding: 5px;
    margin-left: 5px;
    background-color: transparent;
    color: #FFFF;
  }

  .selected-segment{
    background-color: #6f43c1 ;
    color: #FFFF;
    padding: 10px;
    margin-bottom: 20px;
    border-radius: 8px;
    margin-right: 8px;
  }
  .selected-segments{
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .contract-flash-offer p {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    margin-left: 10px;
    margin-bottom: 0px !important;
  
  }
  @media (max-width: 480px) {
    .maps-location{
        margin-top: 0px !important;
    }
    .register-container-col{
        padding: 16px !important;
    }
    .referans-code-section{
        margin-bottom: 12px !important;

    }
    .companyRegisterForm{
        padding-left: 8px;
        padding-right: 8px;
        padding-bottom: 32px;
        padding-top: 32px;
        margin-bottom: 40px;
    }
    .yerimLogoRegister{
        width: 127px !important;
        height: 100px !important;
    }
    .logoBackgroundDivRegister{
        background-size: 380px !important;
        background-position-x: -90px;
        background-position-y: -70px;
        width: 300px;
        background-repeat: no-repeat;
        margin-bottom: 12px;
    }
    .Links a {
        font-size: 9px !important;
    }
    .selected-segments{
        margin-bottom: 10px;
    }
    .selected-segment{
        font-size: 10px;
        padding: 8px;

    }

    
    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{
        height: 60px;
    }
    .RegisterTitle{
        font-size: 25px;
        width: 300px;
    }
    .RegisterSubtitle{
        width: 300px;
    }

    .restaurant-opening-closing-hours{
        display: grid !important;
    }
    .restaurant-opening-closing-hours select{
        width: 85vw !important;
        margin-bottom:24px;
        background-color: #FFFF;
    }
    .signUpButton{
        width: 100%;
    }
   
    .contract-flash-offer p{
        margin-top: 0px !important;
        margin-left: 6px;
        line-height: 15px !important;
        font-weight: 400;
        font-size: 8px !important;
        line-height: 10px !important;
        border-radius: 10px;
        width: 100% !important;
    }
    .checkbox{
        width:25px !important;
        padding: 0px !important;
    }

    .uploadImage{
        padding: 12px;
        display: grid;
        text-align: center;
        align-items: center;

    }
    .uploadImage label {
        font-size: 16px !important;
        line-height: 26px;
        margin-top: 24px;
        margin-bottom: 24px;
    }
    .uploadCompanyLogoImage{
        padding: 5px;
    }
   
}


@media (min-width: 481px) and (max-width: 768px) {
    .maps-location{
        margin-top: 0px !important;
    }
    .register-container-col{
        padding: 16px !important;
    }
    .referans-code-section{
        margin-bottom: 12px !important;

    }
    .companyRegisterForm{
        padding-left: 8px;
        padding-right: 8px;
        padding-bottom: 32px;
        padding-top: 32px;
        margin-bottom: 40px;
    }
    .yerimLogoRegister{
        width: 127px !important;
        height: 100px !important;
    }
    .logoBackgroundDivRegister{
        background-size: 380px !important;
        background-position-x: -90px;
        background-position-y: -70px;
        width: 300px;
        background-repeat: no-repeat;
        margin-bottom: 12px;
    }
    .Links a {
        font-size: 10px !important;
    }
    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{
        height: 60px;
    }
    .RegisterTitle{
        font-size: 25px;
        width: 300px;
    }
    .RegisterSubtitle{
        width: 350px;
    }
    .restaurant-opening-closing-hours {
        display: grid !important;

    }
    .restaurant-opening-closing-hours select{
        width: 400px !important;
        margin-bottom:24px;
        background-color: #FFFF;

    }
    .signUpButton{
        width: 100%;
    }
   
    .contract-flash-offer p{
        font-size: 10px !important;
        line-height: 15px !important;
        margin-left: 26px;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .maps-location{
        margin-top: 0px !important;
    }
    .yerimLogoRegister{
        width: 127px !important;
        height: 100px !important;
    }
    .logoBackgroundDivRegister{
        background-size: 380px !important;
        background-position-x: -90px;
        background-position-y: -70px;
        width: 300px;
        background-repeat: no-repeat;
        margin-bottom: 12px;
    }
    .Links a {
        font-size: 12px !important;
    }
    .RegisterTitle{
        font-size: 25px;
        width: 300px;
    }
    .RegisterSubtitle{
        width: 350px;
    }
    .restaurant-opening-closing-hours {
        display: grid !important;

    }
    .restaurant-opening-closing-hours select{
        width:26vw !important;
        margin-bottom: 24px;
    }
    .signUpButton{
        width: 100%;
    }
    .logoBackgroundDivRegister{
        width: 300px;
    }
    .contract-flash-offer p{
        font-size: 10px !important;
        line-height: 15px !important;
        margin-left: 26px;

    }
}


@media (min-width: 1025px) {
    .Links a {
        font-size: 14px !important;
    }
    .RegisterTitle{
        width: 500px;
    }
    .restaurant-opening-closing-hours select{
        width: 200px !important;
        margin-bottom: 24px;
    }
}


@media (min-width: 1200px) {
    
    .RegisterTitle{
        width: 650px;
    }
    .restaurant-opening-closing-hours select{
        width: 270px !important;
    }
}


@media (min-width: 1400px) {
    
    .restaurant-opening-closing-hours select{
        width: 330px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/RegisterPage.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC;AACA;IACI,yBAAyB;;AAE7B;AACA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;AACA,kCAAkC;AAClC;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,yDAA+C;IAC/C,YAAY;IACZ,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,cAAc;;AAElB;AACA;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;AACjB;;;AAGA;IACI,uBAAuB;AAC3B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,qBAAqB;;AAEzB;;;AAGA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;;IAEE,MAAM;IACN,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;;AAGF;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;AAEF;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;;EAE/B;EACA;IACE;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,8BAA8B;;IAElC;IACA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,oBAAoB;QACpB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;QACI,iCAAiC;QACjC,4BAA4B;QAC5B,4BAA4B;QAC5B,YAAY;QACZ,4BAA4B;QAC5B,mBAAmB;IACvB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,YAAY;;IAEhB;;;IAGA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,wBAAwB;IAC5B;IACA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,4BAA4B;QAC5B,gBAAgB;QAChB,yBAAyB;QACzB,4BAA4B;QAC5B,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,qBAAqB;QACrB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,aAAa;QACb,kBAAkB;QAClB,mBAAmB;;IAEvB;IACA;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;;AAEJ;;;AAGA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,8BAA8B;;IAElC;IACA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,oBAAoB;QACpB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;QACI,iCAAiC;QACjC,4BAA4B;QAC5B,4BAA4B;QAC5B,YAAY;QACZ,4BAA4B;QAC5B,mBAAmB;IACvB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,wBAAwB;;IAE5B;IACA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,uBAAuB;;IAE3B;IACA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;QACI,iCAAiC;QACjC,4BAA4B;QAC5B,4BAA4B;QAC5B,YAAY;QACZ,4BAA4B;QAC5B,mBAAmB;IACvB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,wBAAwB;;IAE5B;IACA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,iBAAiB;;IAErB;AACJ;;;AAGA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,YAAY;IAChB;IACA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;;AAGA;;IAEI;QACI,YAAY;IAChB;IACA;QACI,uBAAuB;IAC3B;AACJ;;;AAGA;;IAEI;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":["* {\n    font-family: 'Sora', sans-serif;\n}\n#root{\n    background-color: #F1F5F7;\n\n}\n.yerimLogoRegister{\n    width: 229px !important;\n    height: 180px !important;\n    margin-bottom: 35px;\n}\n\n.register-container-col{\n    background-color: #FFFF;\n    padding: 72px !important;\n}\n.css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{\n    /* margin-bottom: 24px; */\n    height: 60px !important;\n}\n.css-md26zr-MuiInputBase-root-MuiOutlinedInput-root{\n    margin-bottom: 24px;\n    height: 60px !important;\n}\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{\nbackground-color: white !important;\n}\n.companyRegisterForm {\n    background-color: #F9FBFC;\n    padding: 32px;\n    border-radius: 20px;\n    margin-bottom: 50px;\n}\n.companyInfoTitle{\n    font-weight: 200;\n    margin-top: 50px;\n}\n.logoBackgroundDivRegister {\n    background-image: url(../images/Pattern\\ 2.png);\n    width: 400px;\n    background-position: right;\n    background-size: 460px;\n    margin-bottom: 100px;\n}\n\n.RegisterTitle {\n    font-weight:100;\n    width: 700px;\n    font-size: 36px;\n    line-height: 46px;\n    color: #1D1E25;\n\n}\n\n.RegisterSubtitle {\n    font-weight: 200;\n    width: 500px;\n    font-size: 16px;\n    line-height: 26px;\n    color: #1D1E25;\n}\n\n.companyRegisterTitle {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 16px;\n}\n\n#inputArea {\n    background-color: #FFFF;\n    height: 55px;\n    border-radius: 8px;\n    border: 1px solid #1D1E2533;\n    font-size: 16px;\n    font-weight: 300;\n    color: #1D1E25;\n\n}\n#inputArea:focus{\n    -webkit-box-shadow: #e9a46b !important;\n    box-shadow: none;\n    border: 2px solid #F9B061;\n    outline: none;\n}\n\n#select-box{\n    color: #1D1E2566 !important;\n}\n#select-box:focus{\n    -webkit-box-shadow: #e9a46b !important;\n    box-shadow: none;\n    border: 2px solid #F9B061;\n    outline: none;\n}\n\n\n.css-152mnda-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled{\n    color: black !important;\n}\n.form-control{\n    margin-bottom: 0px !important;\n}\n.input-container {\n    position: relative;\n    margin-bottom: 1.5rem;\n\n}\n\n\n.input-container label {\n    position: absolute;\n    top: 50%;\n    left: 2.5rem; \n    transform: translateY(-50%);\n    color: #1D1E25;\n    font-weight: 300;\n    transition: all 0.2s ease;\n    pointer-events: none;\n  }\n  \n  .input-container input:focus + label,\n  .input-container input:not(:placeholder-shown) + label {\n    top: 0;\n    left: 2.5rem;\n    transform: translateY(15%);\n    font-size: 0.60rem;\n    color: #1D1E25;\n  }\n  \n  .input-container input {\n    padding: 0.75rem 2.5rem;\n  }\n\n\n.input-container select {\n    padding-left: 50px;\n    font-size: 16px;\n    font-weight: 400;\n    width: 100%;\n    height: 50px;\n    border-radius: 8px;\n    border: 1px solid #1D1E2533;\n    font-size: 16px;\n    font-weight: 300;\n    color: #1D1E25 !important;\n    outline: none;\n}\n.weblink{\n    margin-right: 35px !important;\n}\n.icons {\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 50%;\n    left: 15px;\n    transform: translateY(-50%);\n    pointer-events: stroke;\n}\n\n.input-container input::placeholder {\n    padding-left: 10px;\n}\n\n.input-container select {\n    padding-left: 50px;\n    color: #1D1E25;\n    font-size: 16px;\n    font-weight: 400;\n  }\n  \n.input-container input {\n    padding-left: 40px;\n}\n.website-link input{\n    padding-left: 62px;\n}\n.website-link input::placeholder{\n    padding-left: 0px;\n}\n.uploadCompanyLogoImage{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 25px;\n    background-color: #FFFF;\n    border: 2px dashed #1D1E2533;\n    border-radius: 15px;\n    margin-bottom: 30px;\n    font-size: 14px;\n    color: #1D1E25;\n    font-weight: 200;\n}\n.uploadImage {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 25px;\n    background-color: #FFFF;\n    border: 2px dashed #1D1E2533;\n    border-radius: 15px;\n    margin-bottom: 30px;\n    font-size: 14px;\n    color: #1D1E2566;\n    font-weight: 200;\n}\n\n.uploadImage label {\n    margin-left: 15px;\n}\n\n.uploadImage input[type=\"file\"] {\n    margin-top: -50px;\n    cursor: pointer !important;\n}\n\n.uploadImageIcon {\n    padding: 20px;\n    background-color: #F1F5F7;\n    z-index: -1;\n    border-radius: 35px;\n}\n\n.infoPassword {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    margin-bottom: 20px;\n    margin-top: 20px;\n}\n\n.uploadPDF {\n    display: grid;\n    align-items: center;\n    justify-content: center;\n    justify-items: center;\n    padding: 35px;\n    background-color: #FFFF;\n    border: 2px dashed #1D1E2533;\n    margin-bottom: 30px;\n    border-radius: 15px;\n    font-size: 14px;\n    color: #1D1E25;\n    font-weight: 200;\n}\n\n.uploadPDFIcon {\n    padding: 20px;\n    background-color: #87CCA1;\n    margin-bottom: 15px;\n    z-index: -1;\n    border-radius: 35px;\n}\n\n.uploadPDF input[type=\"file\"] {\n    cursor: pointer !important;\n}\n\n.signUpButton {\n    background-color: #F15F50;\n    justify-content: space-between;\n    border: none;\n    padding: 18px 22px 18px 22px;\n    width: 312px;\n    height: 56px;\n    border-radius: 12px;\n}\n.signUpButton:hover{\n    background-color: #ed5746;\n}\n.bottomLinks {\n    text-align: right;\n}\n\n.link {\n    margin-top: 10px;\n    font-size: 16px;\n    color: #1D1E25;\n    font-weight: 400;\n}\n\n.select-container {\n    color: #1D1E25 !important;\n    display: flex;\n    align-items: center;\n    margin-bottom: 24px;\n  }\n  \n  .dropdown-icon {\n    margin-left: -30px;\n    cursor: pointer;\n  }\n\n  .remove-segment-button{\n    border: none;\n    padding: 5px;\n    margin-left: 5px;\n    background-color: transparent;\n    color: #FFFF;\n  }\n\n  .selected-segment{\n    background-color: #6f43c1 ;\n    color: #FFFF;\n    padding: 10px;\n    margin-bottom: 20px;\n    border-radius: 8px;\n    margin-right: 8px;\n  }\n  .selected-segments{\n    margin-bottom: 20px;\n    margin-top: 10px;\n  }\n\n  .contract-flash-offer p {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    margin-left: 10px;\n    margin-bottom: 0px !important;\n  \n  }\n  @media (max-width: 480px) {\n    .maps-location{\n        margin-top: 0px !important;\n    }\n    .register-container-col{\n        padding: 16px !important;\n    }\n    .referans-code-section{\n        margin-bottom: 12px !important;\n\n    }\n    .companyRegisterForm{\n        padding-left: 8px;\n        padding-right: 8px;\n        padding-bottom: 32px;\n        padding-top: 32px;\n        margin-bottom: 40px;\n    }\n    .yerimLogoRegister{\n        width: 127px !important;\n        height: 100px !important;\n    }\n    .logoBackgroundDivRegister{\n        background-size: 380px !important;\n        background-position-x: -90px;\n        background-position-y: -70px;\n        width: 300px;\n        background-repeat: no-repeat;\n        margin-bottom: 12px;\n    }\n    .Links a {\n        font-size: 9px !important;\n    }\n    .selected-segments{\n        margin-bottom: 10px;\n    }\n    .selected-segment{\n        font-size: 10px;\n        padding: 8px;\n\n    }\n\n    \n    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{\n        height: 60px;\n    }\n    .RegisterTitle{\n        font-size: 25px;\n        width: 300px;\n    }\n    .RegisterSubtitle{\n        width: 300px;\n    }\n\n    .restaurant-opening-closing-hours{\n        display: grid !important;\n    }\n    .restaurant-opening-closing-hours select{\n        width: 85vw !important;\n        margin-bottom:24px;\n        background-color: #FFFF;\n    }\n    .signUpButton{\n        width: 100%;\n    }\n   \n    .contract-flash-offer p{\n        margin-top: 0px !important;\n        margin-left: 6px;\n        line-height: 15px !important;\n        font-weight: 400;\n        font-size: 8px !important;\n        line-height: 10px !important;\n        border-radius: 10px;\n        width: 100% !important;\n    }\n    .checkbox{\n        width:25px !important;\n        padding: 0px !important;\n    }\n\n    .uploadImage{\n        padding: 12px;\n        display: grid;\n        text-align: center;\n        align-items: center;\n\n    }\n    .uploadImage label {\n        font-size: 16px !important;\n        line-height: 26px;\n        margin-top: 24px;\n        margin-bottom: 24px;\n    }\n    .uploadCompanyLogoImage{\n        padding: 5px;\n    }\n   \n}\n\n\n@media (min-width: 481px) and (max-width: 768px) {\n    .maps-location{\n        margin-top: 0px !important;\n    }\n    .register-container-col{\n        padding: 16px !important;\n    }\n    .referans-code-section{\n        margin-bottom: 12px !important;\n\n    }\n    .companyRegisterForm{\n        padding-left: 8px;\n        padding-right: 8px;\n        padding-bottom: 32px;\n        padding-top: 32px;\n        margin-bottom: 40px;\n    }\n    .yerimLogoRegister{\n        width: 127px !important;\n        height: 100px !important;\n    }\n    .logoBackgroundDivRegister{\n        background-size: 380px !important;\n        background-position-x: -90px;\n        background-position-y: -70px;\n        width: 300px;\n        background-repeat: no-repeat;\n        margin-bottom: 12px;\n    }\n    .Links a {\n        font-size: 10px !important;\n    }\n    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{\n        height: 60px;\n    }\n    .RegisterTitle{\n        font-size: 25px;\n        width: 300px;\n    }\n    .RegisterSubtitle{\n        width: 350px;\n    }\n    .restaurant-opening-closing-hours {\n        display: grid !important;\n\n    }\n    .restaurant-opening-closing-hours select{\n        width: 400px !important;\n        margin-bottom:24px;\n        background-color: #FFFF;\n\n    }\n    .signUpButton{\n        width: 100%;\n    }\n   \n    .contract-flash-offer p{\n        font-size: 10px !important;\n        line-height: 15px !important;\n        margin-left: 26px;\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .maps-location{\n        margin-top: 0px !important;\n    }\n    .yerimLogoRegister{\n        width: 127px !important;\n        height: 100px !important;\n    }\n    .logoBackgroundDivRegister{\n        background-size: 380px !important;\n        background-position-x: -90px;\n        background-position-y: -70px;\n        width: 300px;\n        background-repeat: no-repeat;\n        margin-bottom: 12px;\n    }\n    .Links a {\n        font-size: 12px !important;\n    }\n    .RegisterTitle{\n        font-size: 25px;\n        width: 300px;\n    }\n    .RegisterSubtitle{\n        width: 350px;\n    }\n    .restaurant-opening-closing-hours {\n        display: grid !important;\n\n    }\n    .restaurant-opening-closing-hours select{\n        width:26vw !important;\n        margin-bottom: 24px;\n    }\n    .signUpButton{\n        width: 100%;\n    }\n    .logoBackgroundDivRegister{\n        width: 300px;\n    }\n    .contract-flash-offer p{\n        font-size: 10px !important;\n        line-height: 15px !important;\n        margin-left: 26px;\n\n    }\n}\n\n\n@media (min-width: 1025px) {\n    .Links a {\n        font-size: 14px !important;\n    }\n    .RegisterTitle{\n        width: 500px;\n    }\n    .restaurant-opening-closing-hours select{\n        width: 200px !important;\n        margin-bottom: 24px;\n    }\n}\n\n\n@media (min-width: 1200px) {\n    \n    .RegisterTitle{\n        width: 650px;\n    }\n    .restaurant-opening-closing-hours select{\n        width: 270px !important;\n    }\n}\n\n\n@media (min-width: 1400px) {\n    \n    .restaurant-opening-closing-hours select{\n        width: 330px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
